import { Box, Card, Typography } from '@mui/material';
import { CSSProperties, FC } from 'react';
import classes from './UICard.module.scss';

type UICardProps = {
  title?: string;
  styles?: CSSProperties;
};

const UICard: FC<UICardProps> = ({ title, styles, children }) => {
  return (
    <Card className={classes.cardContainer} sx={{}} style={styles}>
      {title ? (
        <Box
          component={'div'}
          bgcolor="info"
          borderRadius="lg"
          boxShadow="info"
          className={classes.tableTitle}
          style={{ marginTop: !title ? '0px' : '-24px' }}
        >
          <Typography variant="h5" className={classes.title}>
            {title}
          </Typography>
        </Box>
      ) : null}
      <div className={classes.dataWrapper} style={{ paddingTop: title ? '60px' : '20px' }}>
        {children}
      </div>
    </Card>
  );
};

export default UICard;
